/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { Layout } from '@/data/types/Layout';

export const getCancelOrderOmsPage = (): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'CancelOrderOmsPage', id: 'Cancel-Order-OMS-Page' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	}	
}); 
